export default from './followers-menu';



// WEBPACK FOOTER //
// ./app/containers/followers-menu/index.js